export default {
    limitOrders: state => state.limitOrders,
    voucherLimits: state => state.voucherLimits,
};
